export default () => ({
	clicked: false,

	handleClick($event) {
		// If the event is 'defaultPrevented', it means that there was a validation error.
		if (!$event.defaultPrevented) {
			this.clicked = true;
		}
	},
});
